import btoa from 'btoa';
import { getApiClientId, getApiClientSecret, getBaseUrl } from '../config';
import cache from 'memory-cache';

const accessTokenCacheKeyPrefix = 'accessToken';
const tenMinutesInMilliseconds = 10 * 60 * 1000;

async function getRpgLogsApiAccessToken(gameSlug) {
  const accessTokenCacheKey =
    accessTokenCacheKeyPrefix + (gameSlug ? `-${gameSlug}` : '');
  const accessToken = cache.get(accessTokenCacheKey);
  if (accessToken) return accessToken;

  const authHeader =
    'Basic ' +
    btoa(`${getApiClientId(gameSlug)}:${getApiClientSecret(gameSlug)}`);

  const response = await fetch(`${getBaseUrl(gameSlug)}/oauth/token`, {
    method: 'POST',
    headers: {
      Authorization: authHeader,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'grant_type=client_credentials',
  });

  if (response.status === 200) {
    const json = await response.json();

    cache.put(accessTokenCacheKey, json.access_token, tenMinutesInMilliseconds);

    return json.access_token;
  } else {
    throw new Error('Response was not OK: ' + (await response.text()));
  }
}

export default getRpgLogsApiAccessToken;
